export default "__VITE_ASSET__e27fdc7e__"